import React, { useCallback, useEffect } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import useAnalyticsFoStageToolBar from '../../../../labelling/components/stage-toolbar/analytics/useAnalyticsForStageToolBar';
import { CONTROL_TYPES } from '../../../../labelling/components/stage-toolbar/constants';
import useShortcut from '../../../../labelling/providers/hooks/use-shortcut';
import { handleShortcutRegistrationError } from '../../../../labelling/providers/utils/shortcut';
import { canRedoAtom, canUndoAtom, dispatchAtom } from '../../../atoms/label-store-dispatch/dispatch';
import UndoRedoToolbar from './undo-redo-toolbar';
function UndoRedo() {
  const canUndo = useAtomValue(canUndoAtom);
  const canRedo = useAtomValue(canRedoAtom);
  const dispatch = useSetAtom(dispatchAtom);
  let {
    registerHotKeys
  } = useShortcut();
  const {
    sendEventChangeControls
  } = useAnalyticsFoStageToolBar();
  const handleUndo = useCallback(() => {
    dispatch({
      type: 'UNDO'
    });
    sendEventChangeControls({
      action: CONTROL_TYPES.UNDO
    });
  }, [dispatch, sendEventChangeControls]);
  const handleRedo = useCallback(() => {
    dispatch({
      type: 'REDO'
    });
    sendEventChangeControls({
      action: CONTROL_TYPES.REDO
    });
  }, [dispatch, sendEventChangeControls]);
  useEffect(() => {
    const {
      errors,
      removeHotKeys
    } = registerHotKeys([{
      keys: ['Mod', 'z'],
      onAction: e => {
        e.preventDefault();
        handleUndo();
      }
    }, {
      keys: ['Mod', 'Shift', 'z'],
      onAction: e => {
        e.preventDefault();
        handleRedo();
      }
    }]);
    errors.forEach(error => handleShortcutRegistrationError(error));
    return () => {
      removeHotKeys();
    };
  }, [handleUndo, handleRedo, registerHotKeys]);
  return <UndoRedoToolbar canRedo={canRedo} canUndo={canUndo} undoAction={handleUndo} redoAction={handleRedo} />;
}
export default UndoRedo;